module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("exljd"))).then(() => parcelRequire('hEqeo'));